export const DEFAULT_MODEL = 'jr-auto/fast';

export const MAX_TOOL_TURNS = 50;
